import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

// Root layout — providers live in main.tsx, so this is just an Outlet plus
// the scroll reset. Kept as a separate component so we can hang an
// errorElement off the parent route definition without losing children.
export function RootLayout() {
    useScrollToTopOnNavigate();
    return <Outlet />;
}

// Every page change starts at the top (2026-09-08, Bill: on a phone,
// scrolling down Welcome and opening Capabilities landed part-way down it).
// The room pages scroll the window, not a nested box, and RoomShell stays
// mounted across in-room navigation, so nothing else resets the position.
// A hash (`#task-<id>`, `#capabilities-<id>`) is a deep link and keeps its
// own target; only the pathname triggers the reset.
function useScrollToTopOnNavigate() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) return;
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname, hash]);
}
